import { FC } from 'react';
import TrashIcon from '@/assets/trash.svg';
import { Button } from '@/components/ui/button';
import { api } from '@/redux/api';
import { Contact } from '@/types/address-book';
import { isDmpContact, renderContactValue } from './contact-display';

export type ContactListProps = {
  contacts: Contact[];
  organisationId: number;
  addressBookId: string;
  editEnabled: boolean;
};

export const ContactList: FC<ContactListProps> = ({
  contacts,
  organisationId,
  addressBookId,
  editEnabled,
}) => {
  const [deleteAddressBookContact] = api.useDeleteAddressBookContactMutation();

  if (contacts.length === 0) {
    return (
      <p className="text-sm text-gray-500 italic">
        No contacts in this address book.
      </p>
    );
  }

  return (
    <ul className="flex flex-col gap-2">
      {contacts.map((contact) => {
        const dmp = isDmpContact(contact);
        return (
          <li
            className="flex flex-row items-center justify-between gap-2"
            key={contact.contactId ?? contact.name}
          >
            <span className="text-sm">
              {dmp
                ? `DMP Contact name: ${contact.name}`
                : `${contact.name}: ${renderContactValue(contact)}`}
            </span>
            {editEnabled && (
              <Button
                className="place-self-end"
                disabled={dmp}
                onClick={() => {
                  deleteAddressBookContact({
                    organisationId,
                    addressBookId,
                    contactId: contact.contactId ?? '',
                    actionType: 'deleteAddressBookContact',
                  });
                }}
                variant="primary-warning"
              >
                Delete
                <TrashIcon className="h-6" />
              </Button>
            )}
          </li>
        );
      })}
    </ul>
  );
};
